import { type MaybeRefOrGetter, toValue } from 'vue'
import type { Graph, Thing, WithContext } from 'schema-dts'
import { useHead } from '#imports'

export function useJsonld(
  json: MaybeRefOrGetter<
    WithContext<Thing> | WithContext<Thing>[] | Graph | undefined
  >,
) {
  useHead(() => {
    const value = toValue(json)
    if (!value) {
      return {}
    }

    const jsonldArray = Array.isArray(value) ? value : [value]

    return {
      script: jsonldArray.map((item) => ({
        type: 'application/ld+json',
        children: JSON.stringify(item, null, ''),
      })),
    }
  })
}
